<mat-dialog-actions>
    <div class="coil-details">Coil details</div> <mat-icon mat-button mat-dialog-close fontIcon="close"></mat-icon>
  </mat-dialog-actions>
<mat-dialog-content>
    @if(data) {
        <app-coil-detail [coil]="data" [hideTitle]="true" [hideOrderOverview]="true"></app-coil-detail>
    }
</mat-dialog-content>